export const MarketoFormRemoveEmptyFields = (obj: Record<string, any>): Record<string, any> => {
	return Object.entries(obj).reduce((acc, [key, value]) => {
		// Check if the value is not empty
		if (value !== '' && value !== null && value !== undefined) {
			acc[key] = value // Add the non-empty field to the accumulator
		}
		return acc
	}, {} as Record<string, any>)
}
